import { observer } from 'mobx-react';
import { FC } from 'react';
import { MarketplaceFeaturesParams, takerKnowledgeUrl } from '../../constants/marketplace';
import marketplaceStore from '../../store/marketplaceStore';
import { MarketplaceFeatureKey } from '../../types/marketplace';
import { LOCALES } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import { TBooleanInNumber } from '~/types/main';
import { booleanToNumber } from '~/utils/helpers';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import Text, { TEXT } from '~/view/components/Text/Text';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';

const alwaysEnabledFeatures = [
  MarketplaceFeatureKey.Foodics,
  MarketplaceFeatureKey.Marn,
  MarketplaceFeatureKey.ProductFeed,
  MarketplaceFeatureKey.GoogleMaps,
  MarketplaceFeatureKey.Mobile,
  MarketplaceFeatureKey.Checkout,
  MarketplaceFeatureKey.ApplePay,
  MarketplaceFeatureKey.Wallet,
];

const AvailableFeatureContent: FC = observer((): JSX.Element => {
  const { key, status, donationBranchId } = marketplaceStore.selectedFeature!;
  const { name, configLink, description, extensionComponent: ExtensionComponent } = MarketplaceFeaturesParams[key];

  const handleStatusChange = (status: TBooleanInNumber) => {
    marketplaceStore.changeSelectedFeatureData({ status: Boolean(status), donationBranchId });
  };

  return (
    <ScrollableBlock showScrollbar>
      <p className="family-regular text-size-20 color-gray4 w-60 mt-6 mb-3">{localeStore.t(description || `${name}_description`)} </p>
      <a
        href={takerKnowledgeUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="color-mainblue text-size-20 family-regular w-fit-content d-block"
      >
        {localeStore.t('link_to_knowledge_base')}
      </a>
      {alwaysEnabledFeatures.includes(key) || configLink?.options?.hideEnableToggle ? null : (
        <div className="d-flex align-items-center mt-6">
          <Switcher status={booleanToNumber(status)} onChange={handleStatusChange} />
          <Text type={TEXT.SWITCHER_LABEL} text={localeStore.t('enable')} />
        </div>
      )}
      {ExtensionComponent ? <ExtensionComponent /> : null}
      {configLink && (!configLink?.options?.hideWhenDisabled || status) ? (
        <p className="family-regular text-size-20 mt-5">
          {localeStore.t('configaration_link')}
          {': '}
          <a className={configLink.href ? 'color-mainblue' : 'color-gray4'} href={configLink.href || undefined}>
            {formatPathString(configLink.path)}
          </a>
        </p>
      ) : null}
    </ScrollableBlock>
  );
});

const formatPathString = (strings: string[]): string => {
  const delimiter = localeStore.language === LOCALES.AR ? '<' : '>';

  const formattedStrings: string[] = strings.map((str) => localeStore.t(str));

  return formattedStrings.join(` ${delimiter} `);
};

export default AvailableFeatureContent;
